<template>
	<div style="height: 100%">
		<div class="buttonBox" v-if="showButton">
			<div>
				<div class="chooseButton searchButton" @click="deviceCheckItemInfoEdit('1')" v-if="MenuRoleList.indexOf('209')>=0"><i class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}
				</div>
				<div class="chooseButton searchButton " @click="deviceCheckItemInfoEdit('2')" v-if="MenuRoleList.indexOf('210')>=0"><i class="el-icon-edit-outline"></i>{{$t('btn_15')}}
				</div>
				<div class="chooseButton deleteButton" @click="delEquipmentTypeCheckItem" v-if="MenuRoleList.indexOf('211')>=0"><i class="el-icon-delete"></i>{{$t('btn_16')}}</div>
			</div>
		</div>
		<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableData" highlight-current-row @current-change="handleCurrentChangeTree" border
		 style="width: 100%;margin:  10px 0 10px 0px" height="79%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
			<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
			</el-table-column>
			<el-table-column prop="name" :label="$t('label_340')" align="left">
			</el-table-column>
			<el-table-column prop="remark" :label="$t('btn_29')" align="left">
			</el-table-column>
		</el-table>
		<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
		 @parentMethod="searchPage"></Page>

		<el-dialog v-loading="saveLoading" :title="deviceParamTitle" :visible.sync="dialogDeviceSpot" append-to-body :close-on-click-modal='false'
		 width="400px" top="15%" :before-close="handleClose" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="dialogMes">
					<p><span style="color: #ff0000">*</span>{{$t('label_340')}}</p>
					<div class="mesInput">
						<el-input v-model="tableDataEdit.name" clearable></el-input>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('btn_29')}}</p>
					<div class="mesInput">
						<el-input v-model="tableDataEdit.remark" clearable></el-input>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="tableParamDataEditSave">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import file from "@/assets/js/file/file.js";
	import Page from "@/components/common/page";
	import utils from '@/utils/utils'

	export default {
		name: "maintenanceItem",
		components: {
			Page,
		},
		props: {
			showButton: {
				type: Boolean,
				default: ''
			},
			needSort: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
        saveLoading: false,
				pageNum: 1,
				pageSize: 10,
				MenuRoleList: [],
				tableDataTreeInfo: {},
				tableDataEdit: {
					equipmentId: '',
					name: "",
					remark: '',
				},
				pageCount: 0,
				deviceParamTitle: this.$t('btn_14'),
				dialogDeviceSpot: false,
				tableData: [],
				allDeviceData: [],
				searchDataList: {
					equipmentTypeId: ''
				},
			}
		},
		methods: {
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			newMes(id) {
				this.searchDataList.equipmentTypeId = id;
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			searchPage(param) {
				var dataParam = this.searchDataList;
				var newParam = Object.assign(param, dataParam);
				this.pageNum = newParam.pageNum;
				this.pageSize = newParam.pageSize;
				this.$refs['pageModel'].setCurrent(this.pageNum);
				this.getEquipmentPosition(newParam)
			},
			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				this.searchPage(param)
			},
			handleClose() {
				this.dialogDeviceSpot = false;
				this.tableDataEdit = {
					equipmentId: '',
					name: "",
					remark: '',
				}
			},
			getEquipmentPosition(param) {
				file.getEquipmentPosition(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableData = data.data.records;
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			deviceCheckItemInfoEdit(title) {
				if (title == '2') {
					if (Object.keys(this.tableDataTreeInfo).length > 0) {
						file.getEquipmentPositionMes(this.tableDataTreeInfo.id).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.deviceParamTitle = this.$t('btn_15');
								this.tableDataEdit = data.data;
								this.dialogDeviceSpot = true;
							} else {
                utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					} else {
            utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
					}
				} else {
					this.dialogDeviceSpot = true;
					this.deviceParamTitle = this.$t('btn_14');
				}
			},
			tableParamDataEditSave() {
        this.saveLoading = true;
				if (this.tableDataEdit.name == null || this.tableDataEdit.name == '') {
					utils.messageAlert(this.$t('msg_223'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				if (this.deviceParamTitle == this.$t('btn_14')) {
					this.tableDataEdit.equipmentId = this.searchDataList.equipmentTypeId;
					file.saveEquipmentPosition(this.tableDataEdit).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.dialogDeviceSpot = false;
							this.tableDataEdit = {
								equipmentId: '',
								name: "",
								remark: '',
							}
							this.search();
						} else {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						}
            this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
            this.saveLoading = false;
					})
				} else {
					file.saveEquipmentPositionEdit(this.tableDataEdit).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.dialogDeviceSpot = false;
							this.tableDataEdit = {
								equipmentId: '',
								name: "",
								remark: '',
							}
							this.search();
						} else {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
						}
            this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
            this.saveLoading = false;
					})
				}
			},
			delEquipmentTypeCheckItem() {
				let param = this.tableDataTreeInfo.id;
				if (Object.keys(this.tableDataTreeInfo).length > 0) {
          this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
            confirmButtonText: this.$t('label_100'),
            cancelButtonText: this.$t('btn_1'),
						type: 'warning'
					}).then(() => {
						file.delEquipmentPosition(param).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.search();
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					}).catch(() => {

					});
				} else {
          utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
		},
		created() {
			this.MenuRoleList = this.$store.getters.getMenu;
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/list/displayPage/positionParam.vue